import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Feather, Menu } from "react-feather";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import { addContractorCount } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import FeatherIcon from "feather-icons-react";
import Accordion from "react-bootstrap/Accordion";
import { ADANI_TRI_COLOR_PALATE } from "../../constants/common";
import {
  ACC_COLOR_PALATE,
  AMBUJA_COLOR_PALATE,
  DARPAN_COLOR_PALATE,
  ADANI_COLOR_PALATE,
} from "../../constants/common";
import CircularSlider from "./CircularSlider.js";

const ProgressBar = () => {
  const dispatch = useDispatch();
  const brandId = JSON.parse(localStorage.getItem("currentBrand") || "{}").id;
  const userData = useSelector((state) => state.userTypeSlice.userData);

  const [msg, setMsg] = useState("");
  const [palate, setPalate] = useState([]);
  const [masterTier, setMasterTier] = useState([
    {
      tierId: 1,
      tier_name: "Bronze",
      sequence: 1,
      tier_level: 1,
    },
    {
      tierId: 2,
      tier_name: "Silver",
      sequence: 2,
      tier_level: 2,
    },
    {
      tierId: 3,
      tier_name: "Gold",
      sequence: 3,
      tier_level: 3,
    },
    {
      tierId: 4,
      tier_name: "Platinum",
      sequence: 4,
      tier_level: 4,
    },
  ]);
  const [currentTierData, setCurrentTierData] = useState({});
  const [nextTierData, setNextTierData] = useState({});
  const [currentPoints, setCurrentPoints] = useState("");
  const [noTierPresent, setNoTierPresent] = useState(false);

  async function getBrandThemePalate() {
    let palate = ADANI_COLOR_PALATE;
    const id = brandId;
    switch (id + "") {
      case "1":
        palate = ACC_COLOR_PALATE;
        break;
      case "2":
        palate = AMBUJA_COLOR_PALATE;
        break;
      default:
        palate = ADANI_COLOR_PALATE;
    }
    setPalate(palate);
  }

  useEffect(() => {
    getBrandThemePalate();
  }, [brandId]);

  const getSeq = (tier) => {
    switch (tier) {
      case "Bronze":
        return 1;
      case "Silver":
        return 2;
      case "Gold":
        return 3;
      case "Platinum":
        return 4;
    }
  };

  const fetchNextTierPerformance = async () => {
    try {
      const res = await OtherService.getNextTierPerformance();
      if (res.success) {
        setNoTierPresent(false);
        setMsg(res.response.message);
        if (
          Object.keys(res.response.message) ==
          "Congratulations! You are in the maximum tier."
        ) {
          setCurrentTierData({
            nextTarget: 100,
            percentageAchivedForNextTier: 100,

            tierData: {
              sequence: getSeq(userData.tierName),
              tierId: getSeq(userData.tierName),
              tierName: userData.tierName,
            },
            till_achived: userData.totalPoints,
          });
        } else {
          setNextTierData(res.response.tier_information);
        }
        setCurrentPoints(
          res?.response?.tier_information?.current_accrued_points
        );
      } else {
        setNoTierPresent(true);
      }
    } catch (error) {
      console.error("getMySalePerformanceData api error");
    }
  };

  useEffect(() => {
    fetchNextTierPerformance();
  }, [brandId]);

  useEffect(() => {
    if (
      userData &&
      nextTierData &&
      Object.keys(userData).length > 0 &&
      Object.keys(nextTierData).length > 0
    ) {
      let percent =
        (userData?.totalPoints /
          (userData?.totalPoints + nextTierData?.need_more_points_to_upgrade)) *
        100;
      // dispatch(
      //   addPercentAchieved({
      //     percentAchievedForNextTier: percent,
      //   }),
      // );
      setCurrentTierData({
        nextTarget:
          nextTierData?.need_more_points_to_upgrade + userData?.totalPoints,
        percentageAchivedForNextTier: percent,
        tierData: {
          sequence: getSeq(userData.tierName),
          tierId: getSeq(userData.tierName),
          tierName: userData.tierName,
        },
        till_achived: userData.totalPoints,
      });
    }
  }, [userData, nextTierData]);

  return (
    <>
      <BigBox header="Tier Details" centerContent={true}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "16px",
          }}
        >
          {noTierPresent ? (
            <p style={{ marginTop: "16px", fontWeight: "700" }}>
              No tier present
            </p>
          ) : (
            <>
              <CircularSlider />

              <p style={{ marginTop: "16px", fontWeight: "700" }}>
                You are currently at {formatNumber(currentPoints)} points
              </p>

              {Object.keys(nextTierData).length > 0 && (
                <>
                  {nextTierData?.need_more_points_to_upgrade === 0 ? (
                    <p style={{ marginTop: "8px", fontWeight: "700" }}>
                      You are eligible for {nextTierData?.tier_name} Tier
                    </p>
                  ) : (
                    !!nextTierData?.tier_name && (
                      <p style={{ marginTop: "8px", fontWeight: "700" }}>
                        Need more {nextTierData?.need_more_points_to_upgrade} points
                        to upgrade to {nextTierData?.tier_name}
                      </p>
                    )
                  )}
                  {msg && !nextTierData?.tier_name && (
                    <p style={{ marginTop: "8px", fontWeight: "700" }}>{msg}</p>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </BigBox>
    </>
  );
};

export default ProgressBar;
